import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _cffe3db6 = () => interopDefault(import('~/pages/_.vue' /* webpackChunkName: "" */))
const _fe9de024 = () => interopDefault(import('../../../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/0f879d7c-9611-4a1c-87ef-d933ef7d19bf",
    component: _cffe3db6,
    name: "0f879d7c-9611-4a1c-87ef-d933ef7d19bf"
  }, {
    path: "/2d50f413-d9fd-4ce5-a422-a18c7a6c04c9",
    component: _cffe3db6,
    name: "2d50f413-d9fd-4ce5-a422-a18c7a6c04c9"
  }, {
    path: "/6e7e86dd-72ed-46ec-a635-ecef45d563d0",
    component: _cffe3db6,
    name: "6e7e86dd-72ed-46ec-a635-ecef45d563d0"
  }, {
    path: "/9b4ef87f-7902-430b-8042-3c805ef2ef21",
    component: _cffe3db6,
    name: "9b4ef87f-7902-430b-8042-3c805ef2ef21"
  }, {
    path: "/a0ceb305-716e-4d52-bbef-4d6a73d74dc6",
    component: _cffe3db6,
    name: "a0ceb305-716e-4d52-bbef-4d6a73d74dc6"
  }, {
    path: "/andrea-burckhard",
    component: _cffe3db6,
    name: "andrea-burckhard"
  }, {
    path: "/business-solutions",
    component: _cffe3db6,
    name: "business-solutions"
  }, {
    path: "/c4e3a708-9d73-40f5-8a9d-1d47653e4519",
    component: _cffe3db6,
    name: "c4e3a708-9d73-40f5-8a9d-1d47653e4519"
  }, {
    path: "/calculators",
    component: _cffe3db6,
    name: "calculators"
  }, {
    path: "/concepts-and-strategies",
    component: _cffe3db6,
    name: "concepts-and-strategies"
  }, {
    path: "/copyright",
    component: _cffe3db6,
    name: "copyright"
  }, {
    path: "/d68cf92d-cc4d-4983-899a-f4bba4165382",
    component: _cffe3db6,
    name: "d68cf92d-cc4d-4983-899a-f4bba4165382"
  }, {
    path: "/e0bf1fe8-5d13-491b-a9a3-8d597402e733",
    component: _cffe3db6,
    name: "e0bf1fe8-5d13-491b-a9a3-8d597402e733"
  }, {
    path: "/e5b35e5c-9d41-40d7-ac02-18edc6e19c15",
    component: _cffe3db6,
    name: "e5b35e5c-9d41-40d7-ac02-18edc6e19c15"
  }, {
    path: "/grant-burckhard",
    component: _cffe3db6,
    name: "grant-burckhard"
  }, {
    path: "/helpful-links",
    component: _cffe3db6,
    name: "helpful-links"
  }, {
    path: "/homepage",
    component: _cffe3db6,
    name: "homepage"
  }, {
    path: "/homepage",
    component: _cffe3db6,
    name: "homepage"
  }, {
    path: "/income-tax-strategies",
    component: _cffe3db6,
    name: "income-tax-strategies"
  }, {
    path: "/insurance-and-annuities",
    component: _cffe3db6,
    name: "insurance-and-annuities"
  }, {
    path: "/life-plan-for-business",
    component: _cffe3db6,
    name: "life-plan-for-business"
  }, {
    path: "/lisa-smith",
    component: _cffe3db6,
    name: "lisa-smith"
  }, {
    path: "/location-and-contact",
    component: _cffe3db6,
    name: "location-and-contact"
  }, {
    path: "/matt-harper",
    component: _cffe3db6,
    name: "matt-harper"
  }, {
    path: "/mission-statement",
    component: _cffe3db6,
    name: "mission-statement"
  }, {
    path: "/newsletters",
    component: _cffe3db6,
    name: "newsletters"
  }, {
    path: "/our-holistic-process",
    component: _cffe3db6,
    name: "our-holistic-process"
  }, {
    path: "/personal-solutions",
    component: _cffe3db6,
    name: "personal-solutions"
  }, {
    path: "/refer-a-friend",
    component: _cffe3db6,
    name: "refer-a-friend"
  }, {
    path: "/resources",
    component: _cffe3db6,
    name: "resources"
  }, {
    path: "/schedule-a-consultation",
    component: _cffe3db6,
    name: "schedule-a-consultation"
  }, {
    path: "/special-needs-planning",
    component: _cffe3db6,
    name: "special-needs-planning"
  }, {
    path: "/terry-burckhard",
    component: _cffe3db6,
    name: "terry-burckhard"
  }, {
    path: "/the-nautilus-professional-staff",
    component: _cffe3db6,
    name: "the-nautilus-professional-staff"
  }, {
    path: "/video-library",
    component: _cffe3db6,
    name: "video-library"
  }, {
    path: "/about/1fd6c8de-4abe-4da9-8571-a2024d5c2cc0",
    component: _cffe3db6,
    name: "1fd6c8de-4abe-4da9-8571-a2024d5c2cc0"
  }, {
    path: "/about/41c964a8-8f1b-46ab-b4ed-787417f1ebf1",
    component: _cffe3db6,
    name: "41c964a8-8f1b-46ab-b4ed-787417f1ebf1"
  }, {
    path: "/about/8820c264-a8f8-4338-a62a-20405fd96535",
    component: _cffe3db6,
    name: "8820c264-a8f8-4338-a62a-20405fd96535"
  }, {
    path: "/about/b494e318-32e8-4a23-a322-6113c2992040",
    component: _cffe3db6,
    name: "b494e318-32e8-4a23-a322-6113c2992040"
  }, {
    path: "/about/community-involvement",
    component: _cffe3db6,
    name: "community-involvement"
  }, {
    path: "/about/f151c137-5247-4ac6-9a7e-74acd8300b52",
    component: _cffe3db6,
    name: "f151c137-5247-4ac6-9a7e-74acd8300b52"
  }, {
    path: "/how-we-do-it/dd1e63d1-9645-45a9-946e-50b3a1ae7a8c",
    component: _cffe3db6,
    name: "dd1e63d1-9645-45a9-946e-50b3a1ae7a8c"
  }, {
    path: "/how-we-do-it/homepage",
    component: _cffe3db6,
    name: "homepage"
  }, {
    path: "/how-we-do-it/strategic-alliances",
    component: _cffe3db6,
    name: "strategic-alliances"
  }, {
    path: "/resources/articles",
    component: _cffe3db6,
    name: "articles"
  }, {
    path: "/what-we-do/1b19bfed-e261-4ead-ad23-793e41f56aa3",
    component: _cffe3db6,
    name: "1b19bfed-e261-4ead-ad23-793e41f56aa3"
  }, {
    path: "/what-we-do/suite-of-services",
    component: _cffe3db6,
    name: "suite-of-services"
  }, {
    path: "/resources/articles/4-ways-to-cut-your-tax-bill-in-retirement",
    component: _cffe3db6,
    name: "4-ways-to-cut-your-tax-bill-in-retirement"
  }, {
    path: "/resources/articles/5-reasons-to-see-a-tax-professional",
    component: _cffe3db6,
    name: "5-reasons-to-see-a-tax-professional"
  }, {
    path: "/resources/articles/5-steps-to-financial-freedom-after-divorce",
    component: _cffe3db6,
    name: "5-steps-to-financial-freedom-after-divorce"
  }, {
    path: "/resources/articles/budgeting-for-a-non-budgeter",
    component: _cffe3db6,
    name: "budgeting-for-a-non-budgeter"
  }, {
    path: "/resources/articles/easy-steps-for-starting-a-surprise-fund",
    component: _cffe3db6,
    name: "easy-steps-for-starting-a-surprise-fund"
  }, {
    path: "/resources/articles/financial-basics-for-your-high-school-graduate",
    component: _cffe3db6,
    name: "financial-basics-for-your-high-school-graduate"
  }, {
    path: "/resources/articles/having-control-over-your-day-to-day-finances",
    component: _cffe3db6,
    name: "having-control-over-your-day-to-day-finances"
  }, {
    path: "/resources/articles/how-to-protect-your-small-business-from-a-lawsuit",
    component: _cffe3db6,
    name: "how-to-protect-your-small-business-from-a-lawsuit"
  }, {
    path: "/resources/articles/should-you-combine-your-finances-after-getting-married",
    component: _cffe3db6,
    name: "should-you-combine-your-finances-after-getting-married"
  }, {
    path: "/resources/articles/starting-a-family-the-total-cost-of-a-baby",
    component: _cffe3db6,
    name: "starting-a-family-the-total-cost-of-a-baby"
  }, {
    path: "/",
    component: _cffe3db6,
    name: "99ef0d0d-da24-40eb-9981-baa3abb8a457"
  }, {
    path: "/*",
    component: _fe9de024,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
